import React, { useCallback, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Image } from "react-bootstrap";

import "./InstallTestflightPage.scss";
import FixedFooter from "../../../components/FixedFooter/FixedFooter";
import { OnboardingSteps } from "../../../utils/constants";
import FilledButton, {
  ButtonSizes,
} from "../../../components/dashboard-page/FilledButton/FilledButton";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import TestFlightInstallationFlow from "../../../components/TestFlightInstallationFlow/TestFlightInstallationFlow";
import GhostButton from "../../../components/dashboard-page/GhostButton/GhostButton";
import ImageCloseIcon from "../../../images/close-icon-2.svg";

function InstallTestflightPage() {
  const { goToStep } = useOnboardingSteps();
  const [isCompleted, setIsCompleted] = useState(false);
  const [hasInstalledTestflight, setHasInstalledTestflight] = useState(false);

  const goToNextPage = useCallback(
    () => goToStep(OnboardingSteps.TURN_ON_NOTIFICATIONS),
    [goToStep]
  );

  return (
    <Container className="MobileOnly position-relative InstallTestflightPage px-3">
      <Col>
        <h1 className="d-flex align-items-center justify-content-between">
          <span>Get Hyper App for iPhone</span>
          <GhostButton onClick={goToNextPage}>
            <Image src={ImageCloseIcon} />
          </GhostButton>
        </h1>
      </Col>
      <TestFlightInstallationFlow
        setHasCompletedAllSteps={setIsCompleted}
        hasInstalledTestflight={hasInstalledTestflight}
        setHasInstalledTestflight={setHasInstalledTestflight}
      />
      <FixedFooter>
        <Container className="go-btn-container d-flex justify-content-center mt-0">
          <FilledButton
            size={ButtonSizes.MD}
            onClick={goToNextPage}
            disabled={!isCompleted}
          >
            I have completed step 1 & 2
          </FilledButton>
        </Container>
      </FixedFooter>
    </Container>
  );
}

export default InstallTestflightPage;
